// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"68e5f6f1","703":"ae6f7837","920":"351c0039"}[chunkId] + ".chunk.js";
};